(function (window, document) {
  'use strict';

  const defaultOptions = {
    documentCssClass: 'is--scroll-lock'
  };

  function ScrollLock(options) {

    // Mische die übergebenen Optionen mit den Standardoptionen
    this.options = Object.assign({}, defaultOptions, options);

    // berechnete Scrollbar-Breite des Browsers
    this.scrollbarWidth = null;

    // Plugin intern initialisieren
    this.boot();
  }

  ScrollLock.prototype.boot = function() {
  }

  ScrollLock.prototype.isActive = function() {
    return document.body.classList.contains(this.options.documentCssClass);
  }

  ScrollLock.prototype.getScrollbarWidth = function() {
    let currentScrollbarWidth = 0;

    // das Browserfenster hat Scrollbars
    if(document.body.offsetHeight > window.innerHeight) {
      if(this.scrollbarWidth === null) {
        let scrollDiv = document.createElement('div');
        scrollDiv.style.width = '100px';
        scrollDiv.style.height = '100px';
        scrollDiv.style.overflow = 'scroll';
        scrollDiv.style.position = 'absolute';
        scrollDiv.style.top = '-9999px';
        document.body.appendChild(scrollDiv);

        this.scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

        document.body.removeChild(scrollDiv);
      }

      currentScrollbarWidth = this.scrollbarWidth;
    }

    return currentScrollbarWidth;
  }

  ScrollLock.prototype.activate = function() {
    this.getScrollbarWidth();
    document.body.classList.add(this.options.documentCssClass);
    mint.fireEvent('scroll-lock.activate', {
      scrollbarWidth: this.getScrollbarWidth()
    });
  }

  ScrollLock.prototype.deactivate = function() {
    document.body.classList.remove(this.options.documentCssClass);
    mint.fireEvent('scroll-lock.deactivate');
  }

  function initialize(options) {
    return new ScrollLock(options);
  }

  mint.components.scrollLock = initialize;
})(window, document);
